import { makeAutoObservable, reaction } from "mobx";
export class FulfillmentFormReactions {
    constructor(params) {
        this.fulfillmentTime = params.fulfillmentTime;
        this.fulfillmentFormController = params.fulfillmentFormController;
        makeAutoObservable(this);
    }
    initialize() {
        if (this._clearDisposer || this._refreshDisposer) {
            throw new Error("FulfillmentFormReactions has been already initialized");
        }
        // Clear fulfillment time in the controller & domain if not valid and user has to select again
        this._clearDisposer = reaction(() => this.fulfillmentTime.availability, () => {
            if (this.fulfillmentFormController.type === "Online" &&
                this.fulfillmentTime.domain !== null &&
                this.fulfillmentTime.availability.isAvailable.isDefinitelyFalse) {
                this.fulfillmentFormController.fulfillmentTimeController.clear();
            }
        }, { fireImmediately: true });
        // Update fulfillment time option field to mark proper option as `active` when domain value has been changed after initializing the controller
        this._refreshDisposer = reaction(() => this.fulfillmentTime.isPreorder, () => {
            if (this.fulfillmentFormController.type === "Online" &&
                this.fulfillmentTime.type === "Online" &&
                this.fulfillmentTime.domain !== null) {
                const { fulfillmentOption } = this.fulfillmentFormController.fulfillmentTimeController.fields;
                for (const option of this.fulfillmentTime.options) {
                    if (option.isActive) {
                        fulfillmentOption.change(option.type);
                    }
                }
            }
        });
    }
    dispose() {
        if (this._clearDisposer) {
            this._clearDisposer();
        }
        if (this._refreshDisposer) {
            this._refreshDisposer();
        }
    }
}
